/**
 * @type {Object}
 */
export const CAMPAIGN_AUDIENCE_PERSONA_DEFAULT = {
  cl1: [
    {
      audienceAge: '',
      audienceDescription: '',
      audienceName: '',
      cardType: 'persona-card',
      imageURL: '',
      personaName: '',
      title: 'Persona Card',
      editorPlaceholder: 'Enter audience description',
    },
    {
      cardType: 'text-card',
      content: '',
      editorPlaceholder: 'Enter card description',
      title: 'Top Content',
    },
  ],
  cl2: [
    {
      cardType: 'text-card',
      content: '',
      editorPlaceholder: 'Enter card description',
      title: 'Digital Behavior',
    },
    {
      cardType: 'empathy-persona',
      editorPlaceholder: 'Enter quadrant description',
      title: 'Empathy Map',
      quadrants: {
        think: '',
        feel: '',
        see: '',
        do: '',
      },
    },
  ],
  cl3: [
    {
      cardType: 'text-card',
      content: '',
      editorPlaceholder: 'Enter card description',
      title: 'Use Cases',
    },
    {
      cardType: 'text-card',
      content: '',
      editorPlaceholder: 'Enter card description',
      title: 'Conversation Topics',
    },
    {
      cardType: 'text-card',
      content: '',
      editorPlaceholder: 'Enter card description',
      title: 'Keywords',
    },
  ],
  cl4: [
    {
      cardType: 'word-cloud',
      content: '',
      wordDictionary: '',
      title: 'Word Cloud',
    },
    {
      cardType: 'text-card',
      content: '',
      editorPlaceholder: 'Enter card description',
      title: 'Key Insights',
    },
    {
      cardType: 'text-card',
      content: '',
      editorPlaceholder: 'Enter card description',
      title: 'Persona Quote',
    },
  ],
};
